import BackButton from "../../../../components/Buttons/BackButton";
import BasicButton from "../../../../components/Buttons/BasicButton";
import FormBox from "../../../../components/boxes/FormBox";
import XsCont from "../../../../components/containers/Xs";
import BasicForm from "../../../../components/textField/BasicForm";
import { validationMessage } from "../../../../consts/ValidationMessage";
import { getCognitoUser } from "../../../../utils/cognitoUtils";
import { isValidateEmail } from "../../../../utils/validationUtils";
import { Typography, Box } from "@mui/material";
import { CognitoUser, CognitoUserSession } from "amazon-cognito-identity-js";
import React, { FC, useState } from "react";
import { useNavigate } from "react-router-dom";

type InputEmailStepProps = {
  onNext: () => void;
};

const InputEmailStep: FC<InputEmailStepProps> = ({
  onNext,
}: InputEmailStepProps) => {
  const [form, setForm] = useState({
    email: "",
  });
  const [errors, setErrors] = useState({
    email: "",
  });
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate: () => boolean = (): boolean => {
    let valid: boolean = true;
    const newErrors = {
      email: "",
    };
    const email: string = form.email;
    if (!isValidateEmail(email)) {
      newErrors.email = validationMessage.EMAIL;
      valid = false;
    }
    if (!email) {
      newErrors.email = `メールアドレス${validationMessage.REQUIRED}`;
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const updateEmail = (user: CognitoUser): void => {
    user.updateAttributes(
      [
        {
          Name: "email",
          Value: form.email,
        },
      ],
      (err): void => {
        if (err) {
          navigate("/error");
          return;
        }
        sessionStorage.setItem("newEmail", form.email);
        onNext();
      }
    );
  };

  const handleSubmit: () => Promise<void> = async (): Promise<void> => {
    if (!validate()) return;
    try {
      const loginId: string = sessionStorage.getItem("loginId") || "";
      const user: CognitoUser = getCognitoUser(loginId);

      user.getSession(
        async (
          err: Error | null,
          session: CognitoUserSession
        ): Promise<void> => {
          if (err || !session.isValid()) {
            navigate("/signin");
            return;
          }
          updateEmail(user);
        }
      );
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      setErrors({ email: "エラーが発生しました。" });
    }
  };

  const handleBack: () => void = (): void => {
    navigate("/update");
  };

  return (
    <XsCont>
      <Box mt={10} textAlign="center">
        <Typography variant="h5" gutterBottom>
          メールアドレス変更
        </Typography>
      </Box>
      <FormBox mt={15}>
        <BasicForm
          label={"メールアドレス"}
          name={"email"}
          value={form.email}
          onChange={handleChange}
          error={!!errors.email}
          helperText={errors.email}
        />
      </FormBox>
      <Box mt={10} display="flex" flexDirection="column">
        <BasicButton onClick={handleSubmit} mt={2}>
          次へ
        </BasicButton>
        <BackButton mt={2} onClick={handleBack}>
          キャンセル
        </BackButton>
      </Box>
    </XsCont>
  );
};

export default InputEmailStep;
